const ShareIOsIcon = () => (
  <svg
    viewBox="-1 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Book-now-card" transform="translate(-354.000000, -18.000000)">
        <g id="Group-44">
          <g id="Share_icon" transform="translate(354.000000, 18.000000)">
            <g
              id="upload-1"
              strokeWidth="1"
              transform="translate(0.833333, 7.500000)"
              stroke="#3C3C3C"
            >
              <polyline
                id="Fill-1"
                strokeWidth="1.25"
                points="0 0 0 10.8333333 18.3333333 10.8333333 18.3333333 0.0819172512"
              />
            </g>
            <g id="Page" strokeWidth="1" fill="#3C3C3C">
              <polygon
                id="Fill-1"
                points="-3799.83375 -29.58175 -3799.08542 -28.8000833 -3796.61458 -31.36925 -3796.61458 -20.1659167 -3795.55208 -20.1659167 -3795.55208 -31.36925 -3793.08125 -28.8000833 -3792.33375 -29.58175 -3796.08375 -33.5000833"
              />
              <g id="Fill-1">
                <polygon points="-3799.83375 -29.58175 -3799.08542 -28.8000833 -3796.61458 -31.36925 -3796.61458 -20.1659167 -3795.55208 -20.1659167 -3795.55208 -31.36925 -3793.08125 -28.8000833 -3792.33375 -29.58175 -3796.08375 -33.5000833" />
              </g>
            </g>
            <polygon
              id="SVGID_1_"
              fill="#3C3C3C"
              points="6.55378113 4.98887092 9.41145675 2.25152253 9.41145675 14.1607655 10.6472084 14.1607655 10.6472084 2.25152253 13.504884 4.98887092 14.3737719 4.15344641 10.0100239 -0.00590114372 5.68489327 4.15344641"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ShareIOsIcon;
